module.exports = __webpack_public_path__ + "media/Feuer.9fa95533.mp3";